type TReactionConfig = {
  popupWidth: number;
  popupHeight: number;
};

export const reactionConfig: TReactionConfig = {
  popupWidth: 376,
  popupHeight: 164,
};
